import { useMutation } from '@tanstack/react-query'

import { updateSteeringCapabilities } from '@/features/resource/endpoints/resources'
import type { SteeringCapabilitiesSchemaType } from '@/features/resource/types'

export function useUpdateSteeringCapabilitiesMutation(resourceID: string) {
  const { mutateAsync, ...mutationResult } = useMutation({
    mutationFn: (data: SteeringCapabilitiesSchemaType) => {
      return updateSteeringCapabilities(resourceID, data.isReleaseControlSupported, data.minReleaseControlTimeInSeconds)
    },
  })

  return {
    updateSteeringCapabilities: mutateAsync,
    ...mutationResult,
  }
}
